// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/back.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./img/apply.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("./img/next.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("./img/jsoneditor.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("./img/save.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("./img/close.svg", import.meta.url);
// Module
var code = `<!-- this template is managed by the parent grid -->
<div class="card-container">
  <div class="card-header grid-drag-target edit-mode">
    <div class="card-title"></div>
    <div id="search" class="card-search hide">
      <input id="search-text" type="text" placeholder="Search..." />
    </div>
    <div class="card-actions">
      <div id="prev-button" class="card-button hide"><img src="${___HTML_LOADER_IMPORT_0___}" class="toolbar-img" alt="back"></div>
      <div id="apply-button" class="card-button hide"><img src="${___HTML_LOADER_IMPORT_1___}" class="toolbar-img" alt="apply"></div>
      <div id="next-button" class="card-button hide"><img src="${___HTML_LOADER_IMPORT_2___}" class="toolbar-img" alt="next"></div>
      <div id="edit-json" class="card-button edit-mode"><img src="${___HTML_LOADER_IMPORT_3___}" class="toolbar-img" alt="edit"></div>
      <div id="save-json" class="card-button edit-mode hide"><img src="${___HTML_LOADER_IMPORT_4___}" class="toolbar-img" alt="save"></div>
      <div id="close-button" class="card-button edit-mode"><img src="${___HTML_LOADER_IMPORT_5___}" class="toolbar-img" alt="close"></div>
    </div>
  </div>
  <div class="card-body">
  </div>
</div>
`;
// Exports
export default code;